module.exports = __webpack_public_path__ + "static/media/prize-package-icon.c068eb9d.svg";